"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyBody2 = exports.typographyBody1 = exports.typographySubtitle2 = exports.typographySubtitle1 = exports.typographyTitle = exports.typographyLabelAction = exports.typographyLabelButton = exports.typographyLabelForm = exports.typographyTextSupportForm = exports.typographyTextSupport = exports.typographyTextParagraph = exports.typographyH6 = exports.typographyH5 = exports.typographyH4 = exports.typographyH3 = exports.typographyH2 = exports.typographyH1 = exports.typographyBase = void 0;

var _stylitas = require("@creditas/stylitas");

const typographyBase = ({
  textAlign
}) => (0, _stylitas.css)`
  margin: 0;
  padding: 0;
  text-align: ${textAlign};
`;

exports.typographyBase = typographyBase;

const typographyH1 = ({
  variant,
  theme
}) => variant === 'h1' && (0, _stylitas.css)`
    color: ${theme.bHeadingh1Color};
    font-family: ${theme.bHeadingh1FontFamily},
      ${theme.bHeadingh1FallbackFontFamily};
    font-size: ${theme.bHeadingh1FontSize};
    font-weight: ${theme.bHeadingh1FontWeight};
    line-height: ${theme.bHeadingh1LineHeight};
  `;

exports.typographyH1 = typographyH1;

const typographyH2 = ({
  variant,
  theme
}) => variant === 'h2' && (0, _stylitas.css)`
    color: ${theme.bHeadingh2Color};
    font-family: ${theme.bHeadingh2FontFamily},
      ${theme.bHeadingh2FallbackFontFamily};
    font-size: ${theme.bHeadingh2FontSize};
    font-weight: ${theme.bHeadingh2FontWeight};
    line-height: ${theme.bHeadingh2LineHeight};
  `;

exports.typographyH2 = typographyH2;

const typographyH3 = ({
  variant,
  theme
}) => variant === 'h3' && (0, _stylitas.css)`
    color: ${theme.bHeadingh3Color};
    font-family: ${theme.bHeadingh3FontFamily},
      ${theme.bHeadingh3FallbackFontFamily};
    font-size: ${theme.bHeadingh3FontSize};
    font-weight: ${theme.bHeadingh3FontWeight};
    line-height: ${theme.bHeadingh3LineHeight};
  `;

exports.typographyH3 = typographyH3;

const typographyH4 = ({
  variant,
  theme
}) => variant === 'h4' && (0, _stylitas.css)`
    color: ${theme.bHeadingh4Color};
    font-family: ${theme.bHeadingh4FontFamily},
      ${theme.bHeadingh4FallbackFontFamily};
    font-size: ${theme.bHeadingh4FontSize};
    font-weight: ${theme.bHeadingh4FontWeight};
    line-height: ${theme.bHeadingh4LineHeight};
  `;

exports.typographyH4 = typographyH4;

const typographyH5 = ({
  variant,
  theme
}) => variant === 'h5' && (0, _stylitas.css)`
    color: ${theme.bHeadingh5Color};
    font-family: ${theme.bHeadingh5FontFamily},
      ${theme.bHeadingh5FallbackFontFamily};
    font-size: ${theme.bHeadingh5FontSize};
    font-weight: ${theme.bHeadingh5FontWeight};
    line-height: ${theme.bHeadingh5LineHeight};
  `;

exports.typographyH5 = typographyH5;

const typographyH6 = ({
  variant,
  theme
}) => variant === 'h6' && (0, _stylitas.css)`
    color: ${theme.bHeadingh6Color};
    font-family: ${theme.bHeadingh6FontFamily},
      ${theme.bHeadingh6FallbackFontFamily};
    font-size: ${theme.bHeadingh6FontSize};
    font-weight: ${theme.bHeadingh6FontWeight};
    line-height: ${theme.bHeadingh6LineHeight};
  `;

exports.typographyH6 = typographyH6;

const typographyTextParagraph = ({
  variant,
  theme
}) => variant === 'paragraph' && (0, _stylitas.css)`
    color: ${theme.bTextparagraphColor};
    font-family: ${theme.bTextparagraphFontFamily},
      ${theme.bTextparagraphFallbackFontFamily};
    font-size: ${theme.bTextparagraphFontSize};
    font-weight: ${theme.bTextparagraphFontWeight};
    line-height: ${theme.bTextparagraphLineHeight};
  `;

exports.typographyTextParagraph = typographyTextParagraph;

const typographyTextSupport = ({
  variant,
  theme
}) => variant === 'support' && (0, _stylitas.css)`
    color: ${theme.bTextsupportColor};
    font-family: ${theme.bTextsupportFontFamily},
      ${theme.bTextsupportFallbackFontFamily};
    font-size: ${theme.bTextsupportFontSize};
    font-weight: ${theme.bTextsupportFontWeight};
    line-height: ${theme.bTextsupportLineHeight};
  `;

exports.typographyTextSupport = typographyTextSupport;

const typographyTextSupportForm = ({
  variant,
  theme
}) => variant === 'supportForm' && (0, _stylitas.css)`
    color: ${theme.bTextsupportformColor};
    font-family: ${theme.bTextsupportformFontFamily},
      ${theme.bTextsupportFallbackFontFamily};
    font-size: ${theme.bTextsupportformFontSize};
    font-weight: ${theme.bTextsupportformFontWeight};
    line-height: ${theme.bTextsupportformLineHeight};
  `;

exports.typographyTextSupportForm = typographyTextSupportForm;

const typographyLabelForm = ({
  variant,
  theme
}) => variant === 'form' && (0, _stylitas.css)`
    color: ${theme.bLabelformColor};
    font-family: ${theme.bLabelformFontFamily},
      ${theme.bLabelformFallbackFontFamily};
    font-size: ${theme.bLabelformFontSize};
    font-weight: ${theme.bLabelformFontWeight};
    line-height: ${theme.bLabelformLineHeight};
  `;

exports.typographyLabelForm = typographyLabelForm;

const typographyLabelButton = ({
  variant,
  theme
}) => variant === 'button' && (0, _stylitas.css)`
    color: ${theme.bLabelbuttonColor};
    font-family: ${theme.bLabelbuttonFontFamily},
      ${theme.bLabelbuttonFallbackFontFamily};
    font-size: ${theme.bLabelbuttonFontSize};
    font-weight: ${theme.bLabelbuttonFontWeight};
    line-height: ${theme.bLabelbuttonLineHeight};
    text-transform: ${theme.bLabelbuttonTextTransform};
  `;

exports.typographyLabelButton = typographyLabelButton;

const typographyLabelAction = ({
  variant,
  theme
}) => variant === 'action' && (0, _stylitas.css)`
    color: ${theme.bLabelactionColor};
    font-family: ${theme.bLabelactionFontFamily},
      ${theme.bLabelactionFallbackFontFamily};
    font-size: ${theme.bLabelactionFontSize};
    font-weight: ${theme.bLabelactionFontWeight};
    line-height: ${theme.bLabelactionLineHeight};
    text-transform: ${theme.bLabelbuttonTextTransform};
  `;

exports.typographyLabelAction = typographyLabelAction;

const typographyTitle = ({
  variant,
  ...props
}) => variant === 'title' && (0, _stylitas.css)`
    ${typographyH2({
  variant: 'h2',
  ...props
})};
  `;

exports.typographyTitle = typographyTitle;

const typographySubtitle1 = ({
  variant,
  ...props
}) => variant === 'subtitle1' && (0, _stylitas.css)`
    ${typographyH4({
  variant: 'h4',
  ...props
})};
  `;

exports.typographySubtitle1 = typographySubtitle1;

const typographySubtitle2 = ({
  variant,
  ...props
}) => variant === 'subtitle2' && (0, _stylitas.css)`
    ${typographyH5({
  variant: 'h5',
  ...props
})};
  `;

exports.typographySubtitle2 = typographySubtitle2;

const typographyBody1 = ({
  variant,
  ...props
}) => variant === 'body1' && (0, _stylitas.css)`
    ${typographyTextParagraph({
  variant: 'paragraph',
  ...props
})};
  `;

exports.typographyBody1 = typographyBody1;

const typographyBody2 = ({
  variant,
  ...props
}) => variant === 'body2' && (0, _stylitas.css)`
    ${typographyTextSupport({
  variant: 'support',
  ...props
})};
  `;

exports.typographyBody2 = typographyBody2;